module.exports = __webpack_public_path__ + "static/img/desc_icon.12e6934.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/desc_icon.png
// module id = zs90
// module chunks = 1